export default {
   PREP: {
      OR: {
         en: 'or',
         in: 'atau'
      }
   },
   EMAIL: {
      en: 'Email',
      in: 'Email'
   },
   MESSAGE: {
      ERROR: {
         en: 'Error',
         in: 'Terjadi Kesalahan'
      },
      SUCCESS: {
         en: 'Success',
         in: 'Berhasil'
      },
      SAVE_SUCCESS: {
         en: 'Data Saved Succesful',
         in: 'Data berhasil disimpanl'
      },
   },
   MESSAGE_DETAIL:{
      ERROR_RECIPIENT: {
         en: 'Please Choose Recipient',
         in: 'Penerima Masih Kosong'
      },
      SUCCESS: {
         en: 'Message Successfully Send',
         in: 'Pesan Berhasil Dikirim'
      },
      DELETE: {
         en: 'Message Successfully Delete',
         in: 'Pesan Berhasil Dihapus'
      },
   },
   USER:{
      ID: {
         en: 'User Id',
         in: 'Id Pengguna'
      },
      NAME: {
         en: 'User Name',
         in: 'Nama Pengguna'
      }
   },
   TOTAL:{
      TOTAL_DATA:{
         en: 'Total Data',
         in: 'Jumlah Data'
      }
   },
   EXIT: {
      en: 'Exit',
      in: 'Keluar'
   },
   ADD: {
      en: 'Add',
      in: 'Tambah'
   },
   EDIT:{
      en:"Edit",
      in:"Ubah"
   },
   SAVE: {
      en: 'Save',
      in: 'Simpan'
   },
   CANCEL: {
      en: 'Cancel',
      in: 'Batal'
   },
   CLOSE: {
      en: 'Close',
      in: 'Tutup'
   },
   DELETE: {
      en: 'Delete',
      in: 'hapus'
   },
   SETTINGS:{
      en:"Settings",
      in:"Pengaturan"
   },
   CONFIRMATION: {
      en: 'Confirmation',
      in: 'Konfirmasi'
   },
   DESCRIPTION:{
      en: 'Descrption',
      in: 'Deskripsi'
   },
   REQUIREMENTS:{
      en:"Requirement",
      in:"Kebutuhan"
   },
   COURSE_FOR:{
      en:"Who this course for",
      in:"Diperuntukkan Bagi"
   },
   YES: {
      en: 'Yes',
      in: "Ya"
   },
   NO: {
      en: "No",
      in: "Tidak"
   },
   START: {
      en: 'Start',
      in: 'Mulai'
   },
   NAME: {
      en: "Name",
      in: "Nama"
   },
   SCORE: {
      en: "Score",
      in: "Skor"
   },
   TRUE: {
      en: "True",
      in: "Benar"
   },
   FALSE: {
      en: "False",
      in: "Salah"
   },
   EMPTY: {
      en: "Empty",
      in: "Kosong"
   },
   QUIT: {
      en: "Quit",
      in: "Keluar"
   },
   GENERAL: {
      GENERAL:{
         en: 'General',
         in: 'Umum'
      },
      ADDRESS:{
         en: 'Address',
         in: 'Alamat'
      },
      CITY:{
         en:'City',
         in:'Kota/Kabupaten'
      },
      PROVINCE:{
         en:'Province',
         in:'Provinsi'
      },
      DISTRICT:{
         en:'District',
         in:'Kecamatan'
      },
      TERITORY:{
         en:'Teritory',
         in:'Kelurahan'
      },
      ZIP_CODE:{
         en:'Zip Code',
         in:'Kode Pos'
      },
      DOB:{
         en:'Date of Birth',
         in:'Tanggal Lahir'
      },
      BIRTH_PLACE:{
         en:'Birth Place',
         in:'Tempat Lahir'
      },
      RELIGION:{
         en:'Religion',
         in:'Agama'
      },
      GENDER:{
         en:'Gender',
         in:'Jenis Kelamin'
      },
      CLASS:{
         en:'Class',
         in:"Kelas"
      },
      COURSE:{
         en:"Course",
         in:"Kursus"
      },
      TIME_ZONE:{
         en:"Time Zone",
         in:"Zona Waktu"
      },
      PRINCIPAL:{
         en:"Principal",
         in:"Kepala Sekolah"
      }
   },
   USER_TYPE:{
      NAME:{
         en:'User Type',
         in:'Tipe Pengguna'
      },
      ADMIN:{
         en:'Admin',
         in:'Admin'
      },
      TEACHER:{
         en:'Teacher',
         in:'Pengajar'
      },
      STUDENT:{
         en:'Student',
         in:'Siswa'
      }
   },
   TIME: {
      START: {
         en: 'Start Time',
         in: 'Waktu Mulai'
      },
      END: {
         en: 'End Time',
         in: 'Waktu Berakhir'
      },
      DURATION: {
         en: 'Duration',
         in: 'Durasi'
      },
      MINUTES: {
         en: 'minutes',
         in: 'menit'
      },
      DUE: {
         en: 'Due',
         in: 'Batas Waktu'
      },
      DAY: {
         en: 'Day',
         in: 'Hari'
      },
      TODAY: {
         en: 'Today',
         in: 'Hari ini'
      },
      TOMORROW: {
         en: 'Tomorrow',
         in: 'Besok'
      },
      LATE: {
         en: 'Late',
         in: 'Terlambat'
      }
   },
   LEARNING_CONTENT:{
      TITLE:{
         en:"Learning Content",
         in:"Konten Pembelajaran"
      }
   },
   QUESTION_BANK:{
      TITLE:{
         en:"Question Bank",
         in:"Bank Soal"
      }
   },
   QUIZ:{
      TITLE:{
         en:"Quiz",
         in:"Kuis"
      }
   },
   COURSE_ALLOCATION:{
      TITLE:{
         en:"Allocation",
         in:"Alokasi"
      },
      INPUT_PARTICIPANT:{
         en: "Select Participant",
         in: "Pilih Peserta"
      },
      ALLOCATION_FOR:{
         en: "Allocation for",
         in: "Alokasi untuk"
      },
      ADD_TEACHER:{
         en: "Add Teacher",
         in: "Tambah Pengajar"
      },
      ADD_PARTICIPANT:{
         en: "Add Participant",
         in: "Tambah Peserta"
      },
      PARTICIPANT_ID:{
         en: "Participant Id",
         in: "Id Peserta"
      },
      PARTICIPANT_NAME:{
         en: "Participant Name",
         in: "Nama Peserta"
      },
      TEACHER_NAME:{
         en: "Teacher Name",
         in: "Nama Pengajar"
      }
   },
   WORKPLACE:{
      ADD_WORKPLACE:{
         en: "Add School",
         in: "Tambah Sekolah"
      },
      EDIT_WORKPLACE:{
         en: "Edit School",
         in: "Ubah Sekolah"
      },
      WORKPLACE_ID:{
         en:"School Id",
         in:"Id Sekolah"
      },
      WORKPLACE_NAME:{
         en:"School Name",
         in:"Nama Sekolah"
      },
      CODE:{
         en:"School Code",
         in:"Kode Sekolah"
      },
      NAME_IN_DAPODIK:{
         en:"School Name in Dapodik",
         in:"Nama Sekolah di Laporan"
      }
   },
   PLUGIN_PAGE: {
      QUESTION_TEMPLATE: {
        en: "Template question",
        in: "Soal template"
      },
      QUIZ_WITH_LINK: {
        en: "Quiz with link",
        in: "Kuis dengan link"
      },
      QUIZ_DIAGNOSTIC: {
        en: "Quiz diagnostic",
        in: "Kuis diagnostik"
      },
      SUBJECT_MENU:{
         en: "Subject Menu",
         in: "Menu Mata Pelajaran"
      }
   },
   PAGE:{
      SUBJECT_MENU:{
         en:"Subject",
         in:"Mata Pelajaran"
      },
      COURSE_MENU:{
         en:"Learning Course",
         in:"Kursus Pembelajaran"
      },
      ASSESSMENT_SUBMISSION_MENU:{
         en:"Assessment Submission",
         in:"Pengumpulan Tugas"
      },
      WORKPLACE_MENU:{
         en:"Input Workplace",
         in:"Tambah Workplace"
      },
      SYSTEM_MENU:{
         en:"System",
         in:"Sistem"
      },
      PLUGIN_MENU:{
         en:"Plugin",
         in:"Plugin"
      },
      USER_MENU:{
         en:"User",
         in:"Pengguna"
      },
      CERTIFICATE_MENU:{
         en:"Certificate Download",
         in:"Download Sertifikat"
      },
      MARK_REPORT_MENU:{
         en:"Mark Report",
         in:"Laporan Penilaian"
      },
      ALLOCATION_REPORT_MENU:{
         en:"Allocation Report",
         in:"Laporan Alokasi"
      }
   },
   COURSE_PAGE:{
      COURSE_NAME:{
         en:"Course Name",
         in:"Nama Kursus"
      },
      EDIT_COURSE:{
         en:"Edit Course",
         in:"Ubah Kursus"
      },
      ADD_COURSE:{
         en:"Add Course",
         in:"Tambah Kursus"
      }
   },
   SUBJECT_PAGE:{
      SUBJECT_NAME:{
         en:"Subject Name",
         in:"Nama Mata Pelajaran"
      },
      EDIT_SUBJECT:{
         en:"Edit Subject",
         in:"Ubah Mata Pelajaran"
      },
      ADD_SUBJECT:{
         en:"Add Subject",
         in:"Tambah Mata Pelajaran"
      }
   },
   SYSTEM: {
      FAILED_LOGIN: {
          en: "Failed Login",
          in: "Gagal Login"
      },
      LOCKED: {
          en: "Locked",
          in: "Terkunci"
      },
      CHANGE_PASSWORD: {
          en: "Change Password",
          in: "Ganti Password"
      },
      NEW_PASSWORD: {
          en: "New Password",
          in: "Password Baru"
      },
      NEW_PASSWORD_CONFIRMATION: {
          en: "Confirmation New Password",
          in: "Konfirmasi Password Baru"
      },
      USER: {
          en: "User",
          in: "Pengguna",
      }
   },
}
